import React from "react";
import EnhancedPage from "../../Commen_Component/EnhancedPage";
import { PageEnums } from "../../../_enums/enum.services";

const Headquarter = () => {

    return <EnhancedPage pageId={PageEnums.Headquarter} />
}

export default Headquarter;